import { Wrapper, Icon, Title, Paragraph } from "./styled";

const HeaderPortfolio = () => (
   <Wrapper>
      <Icon />
      <Title>Portfolio</Title>
      <Paragraph>My recent projects</Paragraph>
   </Wrapper>
);

export default HeaderPortfolio;